import { render, staticRenderFns } from "./SocialSetting.vue?vue&type=template&id=28db9a60&scoped=true"
import script from "./SocialSetting.vue?vue&type=script&lang=js"
export * from "./SocialSetting.vue?vue&type=script&lang=js"
import style0 from "./SocialSetting.vue?vue&type=style&index=0&id=28db9a60&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28db9a60",
  null
  
)

export default component.exports